import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ForVendor from "pages/vendorpanel/landingpage";
import MyProfile from "pages/vendorpanel/myprofile";
import Products from "pages/vendorpanel/products";
import AddProduct from "pages/vendorpanel/products/addproduct";
import EditProduct from "pages/vendorpanel/products/editproduct";
import VendorProductDetails from "pages/products/productdetails/VendorProductDetails";
import MySubscription from "pages/vendorpanel/mysubscription";
import DisputeManagement from "pages/vendorpanel/dispute-management";
import MyBadges from "pages/vendorpanel/my-badges";
import ProfilePublic from "pages/vendorpanel/profilepublic";
import Notifications from "pages/vendorpanel/notifications";
import ProfilePage from "pages/vendorpanel/profile";
import { useAuth } from "context/UserContext";
import { toast } from "react-toastify";
const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, user ,wasLoggedIn} = useAuth();
  
  if (!isLoggedIn) {
    if (!wasLoggedIn) {
      toast.error("Please login to access this page", {
        toastId: "login-required"
      });
    }
    return <Navigate to="/" />;
  }

  if (user?.role !== "vendor") {
    toast.error("You are not authorized to access this page", {
      toastId: "unauthorized"
    });
    return <Navigate to="/" />;
  }

  return children;
};
function VendorRoutes() {
  return (
    <Routes>
      <Route path="" element={<ForVendor />} />
      {/* <Route path="/myprofile" element={<ProfilePage />}>
  <Route index element={<MyProfile />} />
</Route> */}

      <Route path="/" element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
           >
        <Route path="myprofile" element={<MyProfile />} />
        <Route path="products" element={<Products />} />
        <Route path="addproduct" element={<AddProduct />} />
        <Route path="editproduct" element={<EditProduct />} />
        {/* <Route path="productdetails" element={<VendorProductDetails />} /> */}
        <Route path="mysubscription" element={<MySubscription />} />
        <Route path="my-badges" element={<MyBadges />} />
        {/* <Route path="profilepublic" element={<ProfilePublic />} /> */}
        <Route path="notifications" element={<Notifications />} />
        <Route path="dispute-management" element={<DisputeManagement />} />
      </Route>
    </Routes>
  );
}

export default VendorRoutes;
